module.exports = __webpack_public_path__ + "img/samu-social.b7552619.jpg";